import styled from 'styled-components';

import { CheckboxRadio } from 'shared/components';
import { FILTER_ENUMS } from 'search/enums/constants';
import { IConstructorFacetMultiple } from 'shared/types/ConstructorFacet';
import { getModalGridTemplateColumnStyle } from 'search/styles/SearchStyles';
import { variableFontRegular } from 'styles/theme';

export interface ISearchMultiSelect {
  facet: IConstructorFacetMultiple;
  name: string;
  numColumns: number;
  selectedFilterValues: Array<string>;
  setSelectedFilterValues: (options: Array<string>) => void;
}

export const SearchMultiSelect = ({
  facet,
  name,
  numColumns,
  selectedFilterValues = [],
  setSelectedFilterValues,
}: ISearchMultiSelect) => {
  const handleOnChange = (optionValue) => {
    if (selectedFilterValues.includes(optionValue)) {
      const updatedValues = selectedFilterValues.filter((value) => {
        return value !== optionValue;
      });
      setSelectedFilterValues(updatedValues);
    } else {
      setSelectedFilterValues([...selectedFilterValues, optionValue]);
    }
  };

  const getLabel = (option) => {
    if (name === FILTER_ENUMS.COLOR) {
      return (
        <SearchMultiSelect.ColorWrapper>
          <SearchMultiSelect.ColorSwatch
            $color={option.data?.hex}
            $swatchUrl={option.data?.web?.imageUrl}
            data-qa="filter_color_swatch"
          />
          <div data-qa="filter_color_name">{option.display_name}</div>
        </SearchMultiSelect.ColorWrapper>
      );
    }
    if (name === FILTER_ENUMS.CONDITION) {
      return (
        <div>
          <SearchMultiSelect.ConditionTitle data-qa="filter_conditions_title">
            {option.display_name}
          </SearchMultiSelect.ConditionTitle>
          <SearchMultiSelect.ConditionDescription data-qa="filter_conditions_description">
            {option.data?.description}
          </SearchMultiSelect.ConditionDescription>
        </div>
      );
    }
    return option.display_name;
  };

  const getStyle = () => {
    if (name === FILTER_ENUMS.COLOR) {
      return { marginBottom: 0 };
    }
  };

  return (
    <>
      {facet.options.map((option) => {
        return (
          <SearchMultiSelect.Checkbox
            data-qa="checkbox_option"
            checked={
              Array.isArray(selectedFilterValues) && selectedFilterValues?.includes(option.value)
            }
            id={option.display_name}
            key={option.display_name}
            label={getLabel(option)}
            labelStyle={getStyle()}
            name={name}
            $numColumns={numColumns}
            onChange={() => handleOnChange(option.value)}
            type="checkbox"
          >
            {name === FILTER_ENUMS.BRAND && (
              <span data-qa="brands_filter_location">
                {option?.data?.location?.split(',')?.[0]}
              </span>
            )}
            <span data-qa="filter_option_count">{option.count.toLocaleString('en-US')}</span>
          </SearchMultiSelect.Checkbox>
        );
      })}
    </>
  );
};

SearchMultiSelect.Checkbox = styled(CheckboxRadio)<{ $numColumns: number }>`
  display: grid;
  grid-template-columns: ${({ $numColumns }) => getModalGridTemplateColumnStyle($numColumns)};
  column-gap: 8px;
  word-break: break-word;
`;

SearchMultiSelect.ColorWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

SearchMultiSelect.ColorSwatch = styled.div<{ $color: string; $swatchUrl?: string }>`
  width: 32px;
  height: 32px;
  margin-right: 8px;
  background: ${({ $color }) => $color || ''};
  background-image: ${({ $swatchUrl }) => $swatchUrl && `url(${$swatchUrl})`};
  background-size: contain;
  cursor: pointer;
`;

SearchMultiSelect.ConditionTitle = styled.div`
  cursor: pointer;
  ${variableFontRegular({ size: '11.5px', height: '16px' })};
`;

SearchMultiSelect.ConditionDescription = styled.div`
  cursor: pointer;
  ${variableFontRegular({ size: '9.5px', height: '12px' })};
`;
